import {
  INVENTORY_ADJUSTMENT_PAGE_REQUEST,
  INVENTORY_ADJUSTMENT_ADJUSTMENTS_REQUEST,
  INVENTORY_ADJUSTMENT_ON_CHANGE_OUTLET_IDS,
  INVENTORY_ADJUSTMENT_ON_CHANGE_DATE,
  INVENTORY_ADJUSTMENT_EXPORT_ADJUSTMENT,
  INVENTORY_ADJUSTMENT_EXPORT_INGREDIENT_ADJUSTMENT,
  INVENTORY_ADJUSTMENT_ON_CLICK_ROW,
  INVENTORY_ADJUSTMENT_ON_CLICK_CREATE_ADJUSTMENT,
  INVENTORY_ADJUSTMENT_ON_CLICK_ADD_ITEMS,
  INVENTORY_ADJUSTMENT_ADD_ITEMS_CANCEL_ADD_ITEMS,
  INVENTORY_ADJUSTMENT_SUBMIT_FORM_CREATE,
  INVENTORY_ADJUSTMENT_ADD_ITEMS_GET_ITEMS_REQUEST,
  INVENTORY_ADJUSTMENT_ADD_ITEMS_GET_INGREDIENTS_REQUEST,
  INVENTORY_ADJUSTMENT_ADD_ITEMS_ON_SEARCH_ITEMS,
  INVENTORY_ADJUSTMENT_ADD_ITEMS_ON_CHANGE_ITEMS,
  INVENTORY_ADJUSTMENT_ADD_ITEMS_CONFIRM_ADD_ITEMS,
  INVENTORY_ADJUSTMENT_ON_CLICK_DONE,
  INVENTORY_ADJUSTMENT_ADJUSTMENT_FORM_ON_CHANGE_OUTLET,
  INVENTORY_ADJUSTMENT_ADJUSTMENT_FORM_ON_CLICK_CANCEL,
  INVENTORY_ADJUSTMENT_CONFIRM_SUBMIT,
  INVENTORY_ADJUSTMENT_ON_CHANGE_NAMESPACE,
  INVENTORY_ADJUSTMENT_INGREDIENT_ADJUSTMENT_REQUEST,
  INVENTORY_ADJUSTMENT_ON_CLICK_ROW_INGREDIENT_ADJUSTMENT,
  INVENTORY_ADJUSTMENT_ON_SUCCESS_IMPORT
} from 'actions/inventory/adjustment/constants'
import * as actInvAdj from 'actions/inventory/adjustment'
import {put, call, takeLatest} from 'redux-saga/effects'
import {delay} from 'redux-saga'
import * as act from 'actions'
import * as actLoadingSpinner from 'actions/loadingSpinner'
import * as apiCurrentInventory from 'api/currentInventoryDropdown'
import * as apiOutlets from 'api/outlets'
import * as apiProfile from 'api/profile'
import * as apiIngInvAdj from 'api/ingredientInventory/adjustment'
import * as apiInvAdj from 'api/inventory/adjustment'
import * as actNotif from 'actions/notifications'
import * as apiGetFilteredDate from 'api/get-filtered-date'
import {initialize, arrayPush, change, reset, arrayRemoveAll} from 'redux-form'
import moment from 'moment'
import * as actGetExportedFile from 'actions/get-exported-file'
import * as apiItems from 'api/items'
import * as apiIng from 'api/ingredients'
import * as apiUpdateFilteredDate from 'api/update-filtered-date'
import * as mpInvAdj from 'mixpanel/inventory/adjustment'
import {subscriptionStatus} from 'actions/inventory/ingredientSubscription'

export function * pageRequest () {
  // ini nanti diganti jadi false waktua adjustment request
  yield put(actLoadingSpinner.showPageLoadingSpinner(true))
  // reset...
  yield put(reset('adjustment'))
  yield put(actInvAdj.setAdjustments([]))
  yield put(actInvAdj.setAdjustmentDetail(null))
  yield put(actInvAdj.setIngredientAdjustmentDetail(null))
  yield put(actInvAdj.closeRightColumn())

  yield put(act.showProgressBar())
  try {
    // get outlets
    let response = yield call(apiOutlets.outlets)
    yield put(actInvAdj.setOutlets(response.data))

    let resProfile = yield call(apiProfile.getProfile)

    // get filtered date
    let resGetFilteredDate = yield call(apiGetFilteredDate.getFilteredDate)
    const startDate = moment(resGetFilteredDate.data.start_date)
    const endDate = moment(resGetFilteredDate.data.end_date)

    // get current dropdown
    let resCurrentInventoryDropdown = yield call(apiCurrentInventory.getCurrentInventoryDropdown)
    const currentInventoryDropdown = resCurrentInventoryDropdown.data.current_inventory_dropdown

    const params = {
      page: 1,
      start: resGetFilteredDate.data.start_date,
      end: resGetFilteredDate.data.end_date
    }

    if (currentInventoryDropdown === 'ingredients') {
      yield put(actInvAdj.ingredientAdjustmentsRequest(params, []))
    } else {
      yield put(actInvAdj.adjustmentsRequest(params, []))
    }

    yield put(initialize('search', {
      outletIds: resProfile.data.outlet_id,
      date: {startDate, endDate},
      namespace: currentInventoryDropdown
    }))
    mpInvAdj.inventoryAdjustmentStart({
      outletIds: resProfile.data.outlet_id,
      startDate,
      endDate,
      namespace: currentInventoryDropdown
    })

    yield put(subscriptionStatus())
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
  }
}

export function * adjustmentsRequest (request) {
  const {payload: {params, previousAdjustments}} = request
  const showLoadingSpinner = previousAdjustments.length === 0
  if (showLoadingSpinner) {
    yield put(actLoadingSpinner.showPageLoadingSpinner(true))
  }
  yield put(act.showProgressBar())
  try {
    const resAdjustments = yield call(apiInvAdj.getAdjustments, params)
    const adjustments = resAdjustments.data.results
    const {total_count, total_expense, total_income, total_items} = resAdjustments.data

    // copy array
    const newAdjustments = previousAdjustments.map(a => a)

    adjustments.forEach((adj, idx) => {
      const lastAdjustment = newAdjustments[newAdjustments.length - 1]
      if (newAdjustments.length === 0 || !moment(adj.created_at).isSame(moment(lastAdjustment.created_at), 'days')) {
        newAdjustments.push({
          created_at: adj.created_at,
          isdaterow: true
        })
      }
      newAdjustments.push({
        ...adj,
        isdaterow: false
      })
    })
    yield put(actInvAdj.setAdjustments(newAdjustments))
    yield put(actInvAdj.setCurrentPage(params.page))
    yield put(actInvAdj.setTotalPage(resAdjustments.data.total_pages))
    yield put(actInvAdj.setSummaryAdjustment({
      totalCount: total_count,
      totalExpense: total_expense,
      totalIncome: total_income,
      totalItems: total_items
    }))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(actLoadingSpinner.showPageLoadingSpinner(false))
  }
}

export function * ingredientAdjustmentRequest (request) {
  const {payload: {params, previousIngredientAdjustments}} = request
  const showLoadingSpinner = previousIngredientAdjustments.length === 0
  if (showLoadingSpinner) {
    yield put(actLoadingSpinner.showPageLoadingSpinner(true))
  }
  yield put(act.showProgressBar())
  try {
    // const resAdjustments = yield call(apiInv.getAdjustments, params)
    const resIngAdjustments = yield call(apiIngInvAdj.getAdjustments, params)
    const ingAdjustments = resIngAdjustments.data.results
    const {total_count, total_expense, total_income, total_ingredients} = resIngAdjustments.data
    // copy array
    const newAdjustments = previousIngredientAdjustments.map(a => a)
    //
    ingAdjustments.forEach((adj, idx) => {
      const lastAdjustment = newAdjustments[newAdjustments.length - 1]
      if (newAdjustments.length === 0 || !moment(adj.created_at).isSame(moment(lastAdjustment.created_at), 'days')) {
        newAdjustments.push({
          created_at: adj.created_at,
          isdaterow: true
        })
      }
      newAdjustments.push({
        ...adj,
        isdaterow: false
      })
    })
    yield put(actInvAdj.setIngredientAdjustments(newAdjustments))
    yield put(actInvAdj.setCurrentPage(params.page))
    yield put(actInvAdj.setTotalPage(resIngAdjustments.data.total_pages))
    yield put(actInvAdj.setSummaryIngredientAdjustment({
      totalCount: total_count,
      totalExpense: total_expense,
      totalIncome: total_income,
      totalIngredients: total_ingredients
    }))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(actLoadingSpinner.showPageLoadingSpinner(false))
  }
}

export function * adjustmentFormOnChangeOutlet () {
  yield put(change('adjustment', 'adjustments', []))
}

export function * adjustmentFormOnClickCancel () {
  yield put(actInvAdj.closeRightColumn())
  yield put(reset('adjustment'))
}

export function * onChangeOutletIdsFlow (request) {
  const {payload: {outletIds, startDate, endDate, namespace}} = request
  mpInvAdj.inventoryAdjustmentChangeFilter({
    outletIds,
    startDate,
    endDate,
    namespace
  })
  yield put(actInvAdj.closeRightColumn())
  yield put(actLoadingSpinner.showPageLoadingSpinner(true))
  yield put(actInvAdj.setAdjustments([]))
  yield put(actInvAdj.setIngredientAdjustments([]))
  yield put(actInvAdj.setAdjustmentDetail(null))
  yield put(actInvAdj.setIngredientAdjustmentDetail(null))
  yield put(reset('adjustment'))
  yield put(act.showProgressBar())
  try {
    yield call(apiOutlets.patchLogin, {id: outletIds})
    yield put(initialize('search', {
      outletIds,
      date: {startDate, endDate},
      namespace
    }))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
  }

  if (namespace === 'ingredients') {
    yield put(actInvAdj.ingredientAdjustmentsRequest({
      page: 1,
      start: moment(startDate).format('YYYY/MM/DD'),
      end: moment(endDate).format('YYYY/MM/DD')
    }, []))
  } else {
    yield put(actInvAdj.adjustmentsRequest({
      page: 1,
      start: moment(startDate).format('YYYY/MM/DD'),
      end: moment(endDate).format('YYYY/MM/DD')
    }, []))
  }
}

export function * onChangeDate (request) {
  const {payload: {startDate, endDate, namespace, outletIds}} = request
  mpInvAdj.inventoryAdjustmentChangeFilter({
    outletIds,
    startDate,
    endDate,
    namespace
  })
  yield put(change('search', 'date', {startDate, endDate}))
  yield put(actInvAdj.closeRightColumn())
  yield put(actLoadingSpinner.showPageLoadingSpinner(true))
  yield put(actInvAdj.setAdjustments([]))
  yield put(actInvAdj.setIngredientAdjustments([]))
  yield put(actInvAdj.setAdjustmentDetail(null))
  yield put(actInvAdj.setIngredientAdjustmentDetail(null))
  yield put(reset('adjustment'))
  if (namespace === 'ingredients') {
    yield put(actInvAdj.ingredientAdjustmentsRequest({
      page: 1,
      start: moment(startDate).format('YYYY/MM/DD'),
      end: moment(endDate).format('YYYY/MM/DD')
    }, []))
  } else {
    yield put(actInvAdj.adjustmentsRequest({
      page: 1,
      start: moment(startDate).format('YYYY/MM/DD'),
      end: moment(endDate).format('YYYY/MM/DD')
    }, []))
  }
}

export function * exportAdjustment (request) {
  const {payload: {params, filename, outletId}} = request
  try {
    yield call(apiInvAdj.getExportAdjustment, params)
    // fetch the result
    yield put(actGetExportedFile.getExportedFile(filename, outletId, 'Adjustment'))
  } catch (error) {
    yield put(actNotif.error(error.message))
  }
}

export function * exportIngredientAdjustment (request) {
  const {payload: {params, filename, outletId}} = request
  try {
    yield call(apiIngInvAdj.getExportAdjustment, params)
    // fetch the result
    yield put(actGetExportedFile.getExportedFile(filename, outletId, 'Ingredient Adjustment'))
  } catch (error) {
    yield put(actNotif.error(error.message))
  }
}

export function * onClickRow (request) {
  const {payload: {adjustment}} = request
  yield put(actInvAdj.setAdjustmentDetail(adjustment))
  yield put(actInvAdj.openRightColumn())
  yield put(initialize('adjustment', {
    outlet_id: adjustment.outlet_id,
    note: ''
  }))
}

export function * onClickRowIngredientAdjustment (request) {
  const {payload: {ingredientAdjustment}} = request
  yield put(actInvAdj.setIngredientAdjustmentDetail(ingredientAdjustment))
  yield put(actInvAdj.openRightColumn())
}

export function * onClickCreateAdjustment (request) {
  const {payload: {outletId}} = request
  yield put(initialize('adjustment', {
    outlet_id: outletId,
    note: '',
    adjustments: []
  }))
  yield put(actInvAdj.setAdjustmentDetail(null))
  yield put(actInvAdj.setIngredientAdjustmentDetail(null))
  yield put(actInvAdj.openRightColumn())
}

export function * onClickAddItems (request) {
  const {payload: {outletId, namespace}} = request
  if (namespace === 'items') {
    yield put(actInvAdj.addItemsGetItemsRequest({
      outlet_id: outletId,
      page: 1,
      per_page: 100,
      no_categories: true,
      keyword: ''
    }, []))
  } else {
    yield put(actInvAdj.addItemsGetIngredientsRequest({
      outlet_id: outletId,
      page: 1,
      per_page: 100,
      keyword: ''
    }, []))
  }
  yield put(actInvAdj.addItemsSetSelectedId(null))
  yield put(actInvAdj.addItemsHideAlreadyAddedAlert())
  yield put(actInvAdj.showAddItemsModal())
  yield put(actInvAdj.addItemsSetItemHasRecipe(false))
}

export function * addItemsCancelAddItems (request) {
  yield put(initialize('addItems', {
    items: []
  }))
  yield put(actInvAdj.hideAddItemsModal())
  yield put(actInvAdj.addItemsSetSelectedId(null))
  yield put(actInvAdj.addItemsSetItemHasRecipe(false))
}

export function * addItemsGetItemsRequestFlow (request) {
  const {payload: {params, previousItems}} = request
  try {
    yield put(actInvAdj.addItemsShowLoading())
    let resItems = yield call(apiItems.getItemsV1, params)
    let items = resItems.data
    const mergedItems = previousItems.concat(items)
    yield put(actInvAdj.addItemsSetItems(mergedItems))

    if (items.length === 0) {
      yield put(actInvAdj.addItemsSetTotalPage(params.page))
    } else {
      yield put(actInvAdj.addItemsSetTotalPage(params.page + 1))
    }
    yield put(actInvAdj.addItemsSetCurrentPage(params.page))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(actInvAdj.addItemsHideLoading())
  }
}

export function * addItemsGetIngredientsRequestFlow (request) {
  const {payload: {params, previousIngredients}} = request
  try {
    yield put(actInvAdj.addItemsShowLoading())
    let resIngs = yield call(apiIng.getAll, params)
    let ingredients = resIngs.data
    const mergedIngredients = previousIngredients.concat(ingredients)
    yield put(actInvAdj.addItemsSetIngredients(mergedIngredients))
    // TODO HACK ini karena backend gak ngasih total pages di api yang support pagination dan filter outlet_id frontend,
    // solusinya totalpage === currentpage + 1 kalo data masih ada
    if (ingredients.length === 0) {
      yield put(actInvAdj.addItemsSetTotalPage(params.page))
    } else {
      yield put(actInvAdj.addItemsSetTotalPage(params.page + 1))
    }
    yield put(actInvAdj.addItemsSetCurrentPage(params.page))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(actInvAdj.addItemsHideLoading())
  }
}

export function * createAdjustment () {
  // TODO
}

export function * addItemsOnSearchItems (request) {
  yield put(actInvAdj.addItemsSetItems([]))
  // delay to prevent too many request
  yield call(delay, 100)
  const {payload: {keyword, outletId, namespace}} = request
  if (namespace === 'items') {
    yield put(actInvAdj.addItemsGetItemsRequest({
      outlet_id: outletId,
      page: 1,
      per_page: 100,
      no_categories: true,
      keyword
    }, []))
  } else {
    yield put(actInvAdj.addItemsGetIngredientsRequest({
      outlet_id: outletId,
      page: 1,
      per_page: 100,
      keyword
    }, []))
  }
  yield put(initialize('addItems', {

  }))
  yield put(actInvAdj.addItemsSetSelectedId(null))
  yield put(actInvAdj.addItemsSetKeyword(keyword))
  yield put(actInvAdj.addItemsHideAlreadyAddedAlert())
  yield put(actInvAdj.addItemsSetItemHasRecipe(false))
}

export function * addItemsOnChangeItems (request) {
  const {payload: {item, namespace, adjustmentForm}} = request
  if (namespace === 'items') {
    const adjustments = adjustmentForm.adjustments

    let alreadyExist = false
    adjustments.forEach((adj) => {
      if (item.id === adj.item_id) {
        alreadyExist = true
      }
    })
    yield put(actInvAdj.addItemsSetSelectedId(item.id))
    if (namespace === 'items') {
      yield put(actInvAdj.addItemsSetItemHasRecipe(item.is_recipe))
    }
    if (alreadyExist) {
      yield put(actInvAdj.addItemsShowAlreadyAddedAlert())
      yield put(initialize('addItems', {}))
    } else {
      // reorder item_variants based on position
      item.item_variants = item.item_variants.sort((iva, ivb) => {
        if (iva.position < ivb.position) {
          return -1
        } else if (iva.position > ivb.position) {
          return 1
        } else {
          return 0
        }
      })
      const fields = item.item_variants.map((iv, index) => {
        return {
          item_variant_name: iv.name,
          beginning_stock: iv.in_stock,
          quantity: iv.in_stock,
          item_id: item.id,
          item_name: item.name,
          item_variant_id: iv.id,
          position: iv.position,
          is_item: item.item_variants.length <= 1
        }
      })
      yield put(initialize('addItems', {
        items: fields
      }))
    }
  } else {
    const ingredients = adjustmentForm.adjustments
    let alreadyExist = false
    ingredients.forEach((ing) => {
      if (item.id === ing.ingredient_id) {
        alreadyExist = true
      }
    })
    yield put(actInvAdj.addItemsSetSelectedId(item.id))
    if (namespace === 'items') {
      yield put(actInvAdj.addItemsSetItemHasRecipe(item.is_recipe))
    }
    if (alreadyExist) {
      yield put(actInvAdj.addItemsShowAlreadyAddedAlert())
    } else {
      yield put(initialize('addItems', {
        adjustment_quantity: 0,
        beginning_stock: item.in_stock.toFixed(2),
        end_stock: item.in_stock.toFixed(2),
        ingredient_category_id: item.ingredient_category_id,
        ingredient_id: item.id,
        ingredient_name: item.name,
        position: 0, // diset manual karena butuh dikirim ke server juga
        quantity: item.in_stock.toFixed(2),
        timestamp: new Date().getTime(),
        total_price: 0, // diset manual karena butuh dikirim ke server juga
        unit_id: item.unit_id,
        unit_name: item.unit_name,
        unit_price: 0 // diset manual karena butuh dikirim ke server juga
      }))
    }
  }
}

export function * addItemsConfirmAddItems (request) {
  const {payload: {addItemsFormValues, adjustments, namespace}} = request
  if (namespace === 'items') {
    const {items} = addItemsFormValues
    // grouping items
    let itemIdsOrderCounter = 0
    const itemIdsOrder = {}
    // order itemIds based of
    adjustments.forEach((adjustment) => {
      if (!itemIdsOrder[adjustment.item_id]) {
        itemIdsOrder[adjustment.item_id] = ++itemIdsOrderCounter
      }
    })
    items.forEach((item) => {
      if (!itemIdsOrder[item.item_id]) {
        itemIdsOrder[item.item_id] = ++itemIdsOrderCounter
      }
    })

    // data-merging
    let newAdjustmetObjectsByItemVariantIds = {}
    adjustments.forEach((adjustment) => {
      if (!newAdjustmetObjectsByItemVariantIds[adjustment.item_variant_id]) {
        newAdjustmetObjectsByItemVariantIds[adjustment.item_variant_id] = adjustment
      } else {
        newAdjustmetObjectsByItemVariantIds[adjustment.item_variant_id].quantity =
          parseInt(newAdjustmetObjectsByItemVariantIds[adjustment.item_variant_id].quantity) + parseInt(adjustment.quantity)
      }
    })

    items.forEach((item) => {
      if (!newAdjustmetObjectsByItemVariantIds[item.item_variant_id]) {
        newAdjustmetObjectsByItemVariantIds[item.item_variant_id] = item
      } else {
        newAdjustmetObjectsByItemVariantIds[item.item_variant_id].quantity =
          parseInt(newAdjustmetObjectsByItemVariantIds[item.item_variant_id].quantity) + parseInt(item.quantity)
      }
    })

    // convert to array
    let newAdjustments = []

    Object.keys(newAdjustmetObjectsByItemVariantIds).forEach((key) => {
      newAdjustments.push(newAdjustmetObjectsByItemVariantIds[key])
    })
    newAdjustments = newAdjustments.sort((a, b) => {
      if (itemIdsOrder[a.item_id] !== itemIdsOrder[b.item_id]) {
        if (itemIdsOrder[a.item_id] < itemIdsOrder[b.item_id]) {
          return -1
        } else {
          return 1
        }
      } else if (a.position !== b.position) {
        if (a.position < b.position) {
          return -1
        } else {
          return 1
        }
      } else {
        return 0
      }
    })

    yield put(arrayRemoveAll('adjustment', 'adjustments'))
    for (let i = 0; i < newAdjustments.length; i++) {
      yield put(arrayPush('adjustment', 'adjustments', newAdjustments[i]))
    }
  } else {
    yield put(arrayPush('adjustment', 'adjustments', addItemsFormValues))
  }

  yield put(actInvAdj.hideAddItemsModal())
  yield put(initialize('addItems', {
    items: []
  }))
  yield put(actInvAdj.addItemsSetSelectedId(null))
  yield put(actInvAdj.addItemsHideAlreadyAddedAlert())
  yield put(actInvAdj.addItemsSetItemHasRecipe(false))
}

export function * onClickDone (request) {
  yield put(actInvAdj.closeRightColumn())
  yield put(actInvAdj.setAdjustmentDetail(null))
}

export function * confirmSubmit (request) {
  const {payload: {values, namespace, date, outlet}} = request
  try {
    yield put(act.showProgressBar())
    yield put(actInvAdj.hideConfirmSubmitModal())
    if (namespace === 'items') {
      const formData = {adjustment: {note: values.note, outlet_id: values.outlet_id}}
      const {adjustments} = values
      formData.adjustment.history_details = []
      adjustments.forEach((a) => {
        if (Math.abs(parseFloat(a.quantity) - parseFloat(a.beginning_stock)) > 0.0000001) {
          formData.adjustment.history_details.push({
            ...a,
            end_stock: a.quantity - a.beginning_stock,
            adjustment: a.quantity - a.beginning_stock
          })
        }
      })
      mpInvAdj.inventoryAdjustmentCreate({adjustment: formData.adjustment, outlet})
      yield call(apiInvAdj.postAdjustment, formData)
    } else {
      const formData = {ingredient_adjustment: {note: values.note, outlet_id: values.outlet_id}}
      const {adjustments} = values
      formData.ingredient_adjustment.ingredient_history_details = []
      adjustments.forEach((a) => {
        formData.ingredient_adjustment.ingredient_history_details.push({
          ...a,
          adjustment_quantity: Math.round((a.quantity - a.beginning_stock) * 100) / 100, // hack utk rounding, kalo ga diround nanti akan ngimirin value spt 0.03999999997
          end_stock: 0, // gatau dari contoh yang lama kenapa dikasih 0 dan instead pake adjustment_quantity
          timestamp: new Date().getTime(),
          total_price: 0 // ni juga kenapa dah dikasih 0,
        })
      })
      mpInvAdj.inventoryAdjustmentCreate({adjustment: formData.ingredient_adjustment, outlet})
      yield call(apiIngInvAdj.postAdjustment, formData)
    }
    // update server date if it is not in range
    if (!moment().isBetween(date.startDate, date.endDate, 'day', '[]')) {
      yield call(apiUpdateFilteredDate.updateFilteredDate, {
        from: moment().format('D/M/YYYY'), to: moment().format('D/M/YYYY')
      })
    }
    yield put(reset('adjustment'))
    yield put(actInvAdj.pageRequest())
    yield put(actNotif.success('Adjustment has been created'))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(actInvAdj.closeRightColumn())
    yield put(act.hideProgressBar())
  }
}

export function * onChangeNamespace (request) {
  const {payload: {namespace, params, startDate, endDate, outletIds}} = request
  mpInvAdj.inventoryAdjustmentChangeFilter({
    outletIds,
    startDate,
    endDate,
    namespace
  })
  // update dropdown
  yield put(actInvAdj.closeRightColumn())
  yield put(act.showProgressBar())
  yield put(actLoadingSpinner.showPageLoadingSpinner(true))
  yield put(actInvAdj.setIngredientAdjustments([]))
  yield put(actInvAdj.setAdjustments([]))
  yield put(actInvAdj.setAdjustmentDetail(null))
  yield put(actInvAdj.setIngredientAdjustmentDetail(null))
  yield put(actInvAdj.cancelAddItems())
  yield put(reset('adjustment'))
  yield put(change('search', 'namespace', namespace))
  try {
    yield call(apiCurrentInventory.putCurrentInventoryDropdown, {current_inventory_dropdown: namespace})
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    if (namespace === 'ingredients') {
      yield put(actInvAdj.ingredientAdjustmentsRequest(params, []))
    } else {
      yield put(actInvAdj.adjustmentsRequest(params, []))
    }
    yield put(act.hideProgressBar())
  }
}

export function * onSuccessImport () {
  yield put(actInvAdj.hideImportModal())
  yield put(actNotif.success('Adjustment successfully imported'))
  yield put(actInvAdj.pageRequest())
}

export default function * saga () {
  yield takeLatest(INVENTORY_ADJUSTMENT_PAGE_REQUEST, pageRequest)
  yield takeLatest(INVENTORY_ADJUSTMENT_ADJUSTMENTS_REQUEST, adjustmentsRequest)
  yield takeLatest(INVENTORY_ADJUSTMENT_ON_CHANGE_OUTLET_IDS, onChangeOutletIdsFlow)
  yield takeLatest(INVENTORY_ADJUSTMENT_ON_CHANGE_NAMESPACE, onChangeNamespace)
  yield takeLatest(INVENTORY_ADJUSTMENT_ON_CHANGE_DATE, onChangeDate)
  yield takeLatest(INVENTORY_ADJUSTMENT_EXPORT_ADJUSTMENT, exportAdjustment)
  yield takeLatest(INVENTORY_ADJUSTMENT_EXPORT_INGREDIENT_ADJUSTMENT, exportIngredientAdjustment)
  yield takeLatest(INVENTORY_ADJUSTMENT_ON_CLICK_ROW, onClickRow)
  yield takeLatest(INVENTORY_ADJUSTMENT_ON_CLICK_ROW_INGREDIENT_ADJUSTMENT, onClickRowIngredientAdjustment)
  yield takeLatest(INVENTORY_ADJUSTMENT_ON_CLICK_CREATE_ADJUSTMENT, onClickCreateAdjustment)
  yield takeLatest(INVENTORY_ADJUSTMENT_ON_CLICK_ADD_ITEMS, onClickAddItems)
  yield takeLatest(INVENTORY_ADJUSTMENT_ADD_ITEMS_CANCEL_ADD_ITEMS, addItemsCancelAddItems)
  yield takeLatest(INVENTORY_ADJUSTMENT_SUBMIT_FORM_CREATE, createAdjustment)
  yield takeLatest(INVENTORY_ADJUSTMENT_ADD_ITEMS_GET_ITEMS_REQUEST, addItemsGetItemsRequestFlow)
  yield takeLatest(INVENTORY_ADJUSTMENT_ADD_ITEMS_GET_INGREDIENTS_REQUEST, addItemsGetIngredientsRequestFlow)
  yield takeLatest(INVENTORY_ADJUSTMENT_ADD_ITEMS_ON_SEARCH_ITEMS, addItemsOnSearchItems)
  yield takeLatest(INVENTORY_ADJUSTMENT_ADD_ITEMS_ON_CHANGE_ITEMS, addItemsOnChangeItems)
  yield takeLatest(INVENTORY_ADJUSTMENT_ADD_ITEMS_CONFIRM_ADD_ITEMS, addItemsConfirmAddItems)
  yield takeLatest(INVENTORY_ADJUSTMENT_ON_CLICK_DONE, onClickDone)
  yield takeLatest(INVENTORY_ADJUSTMENT_ADJUSTMENT_FORM_ON_CHANGE_OUTLET, adjustmentFormOnChangeOutlet)
  yield takeLatest(INVENTORY_ADJUSTMENT_ADJUSTMENT_FORM_ON_CLICK_CANCEL, adjustmentFormOnClickCancel)
  yield takeLatest(INVENTORY_ADJUSTMENT_CONFIRM_SUBMIT, confirmSubmit)
  yield takeLatest(INVENTORY_ADJUSTMENT_INGREDIENT_ADJUSTMENT_REQUEST, ingredientAdjustmentRequest)
  yield takeLatest(INVENTORY_ADJUSTMENT_ON_SUCCESS_IMPORT, onSuccessImport)
}



// WEBPACK FOOTER //
// ./app/sagas/inventory/adjustment.js